import React, {useState, useEffect, Suspense} from "react"

export default function GroupEmail (props) {
    return <div className="rsvptab">group email ui goes here</div>
}